module.exports = __webpack_public_path__ + "img/bytorg_Logo.0ca8f923.svg";